import toPropertyKey from "./toPropertyKey.js";
export default function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/defineProperty.js
// module id = 967
// module chunks = 1